import { useHasMultipleReferralInvites } from './useHasMultipleReferralInvites'

export function useReferralsTerm() {
  const hasMultipleInvites = useHasMultipleReferralInvites()

  return hasMultipleInvites ? 'the referrals' : 'the referral'
}
